import SectionList from "components/sections/SectionList";
import Description from "components/layout/Description";
import Phone from "components/phone/Phone";
import Email from "components/email/Email";
import QuestionWall from "components/questions/QuestionWall";
import Question from "components/questions/Question";
import Confirmation from "components/email/Confirmation";

const Content = ({ module }) => {
	const mainClass = "help-content";

	return module ? (
		<div className={mainClass}>
			{(module?.sections && <SectionList {...module} />) ||
				(module?.phoneData && <Phone {...module} />) ||
				(module?.emailData && <Email {...module} />) ||
				(module?.confirmationData && <Confirmation {...module} />)}
			{module.description !== undefined && <Description {...module} />}
			{module.questions && <QuestionWall module={module}></QuestionWall>}
			{module.question && <Question module={module} />}
		</div>
	) : null;
};

export default Content;
